var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flow-design-form" },
    [
      _c(
        "div",
        { staticClass: "flow-toolbar" },
        [
          _c("a-input", {
            staticStyle: { width: "200px" },
            attrs: { placeholder: "请输入流程名称" },
            model: {
              value: _vm.form.flowName,
              callback: function ($$v) {
                _vm.$set(_vm.form, "flowName", $$v)
              },
              expression: "form.flowName",
            },
          }),
          _c(
            "a-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "选择单据类型", disabled: !!_vm.form.id },
              model: {
                value: _vm.form.billType,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "billType", $$v)
                },
                expression: "form.billType",
              },
            },
            _vm._l(_vm.billTypes, function (n, k) {
              return _c("a-select-option", { key: k, attrs: { value: k } }, [
                _vm._v(_vm._s(n)),
              ])
            }),
            1
          ),
          _c("a-button", { on: { click: _vm.undo } }, [_vm._v("撤销")]),
          _c("a-button", { on: { click: _vm.redo } }, [_vm._v("重做")]),
          _c(
            "a-button",
            { attrs: { size: "small" }, on: { click: _vm.zoomIn } },
            [_vm._v("放大")]
          ),
          _c(
            "a-button",
            { attrs: { size: "small" }, on: { click: _vm.zoomOut } },
            [_vm._v("缩小")]
          ),
          _c(
            "a-button",
            { attrs: { size: "small" }, on: { click: _vm.fitView } },
            [_vm._v("适应")]
          ),
          _c(
            "a-button",
            {
              attrs: { size: "small", type: "danger" },
              on: { click: _vm.deleteSelected },
            },
            [_vm._v("删除选中")]
          ),
          _c(
            "a-button",
            { attrs: { icon: "code" }, on: { click: _vm.showJsonModal } },
            [_vm._v("模板JSON")]
          ),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSave } },
            [_vm._v("保存")]
          ),
          _c("a-button", { on: { click: _vm.handleBack } }, [_vm._v("返回")]),
          _vm.isDefaultFlow
            ? _c(
                "span",
                { staticStyle: { color: "#fa8c16", "margin-left": "12px" } },
                [_vm._v("当前为系统默认流程，保存将生成你自己的方案")]
              )
            : _vm._e(),
          _vm.billTypeEmpty
            ? _c(
                "span",
                { staticStyle: { color: "#f5222d", "margin-left": "12px" } },
                [_vm._v("请先在系统配置→多级审核中勾选需审批的单据")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "flow-designer" }, [
        _c(
          "div",
          { staticClass: "node-panel" },
          [
            _c("div", { staticClass: "panel-title" }, [_vm._v("节点类型")]),
            _vm._l(_vm.nodeTypes, function (n) {
              return _c(
                "div",
                {
                  key: n.type,
                  staticClass: "node-item",
                  on: {
                    mousedown: function ($event) {
                      return _vm.startDrag(n.type, $event)
                    },
                    click: function ($event) {
                      return _vm.addNode(n.type)
                    },
                  },
                },
                [_vm._v(_vm._s(n.label))]
              )
            }),
          ],
          2
        ),
        _c("div", { ref: "flowContainer", staticClass: "flow-canvas" }),
        _c("div", { staticClass: "prop-panel" }, [
          _c("div", { staticClass: "panel-title" }, [_vm._v("属性")]),
          !_vm.currentEdit
            ? _c("div", { staticClass: "panel-tip" }, [
                _vm._v("点击节点或连线进行编辑"),
              ])
            : _vm._e(),
          _vm.currentEdit && _vm.currentEdit.kind === "node"
            ? _c(
                "div",
                [
                  _c(
                    "a-form",
                    { attrs: { layout: "vertical" } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "节点名称" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.editForm.text,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "text", $$v)
                              },
                              expression: "editForm.text",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.currentEdit.bizType === "condition"
                        ? [
                            _c(
                              "a-form-item",
                              { attrs: { label: "分支条件" } },
                              [
                                _vm.conditionEdges.length === 0
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          color: "rgba(0,0,0,0.45)",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "暂无出边，请先从此节点连线到下游节点"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._l(_vm.conditionEdges, function (e, i) {
                                  return _c(
                                    "div",
                                    {
                                      key: i,
                                      staticStyle: { "margin-bottom": "4px" },
                                    },
                                    [
                                      _vm._v(
                                        "分支 " +
                                          _vm._s(i + 1) +
                                          "：" +
                                          _vm._s(e.text)
                                      ),
                                    ]
                                  )
                                }),
                                _c("a-alert", {
                                  staticStyle: { "margin-top": "8px" },
                                  attrs: {
                                    type: "info",
                                    "show-icon": "",
                                    message: "分支条件在连线上配置",
                                    description:
                                      "请点击某条连线，在右侧面板设置「字段 + 操作符 + 值」，或切换为默认分支。",
                                  },
                                }),
                              ],
                              2
                            ),
                          ]
                        : _vm._e(),
                      _vm.currentEdit.bizType === "approval" ||
                      _vm.currentEdit.bizType === "cc"
                        ? [
                            _c(
                              "a-form-item",
                              { attrs: { label: "审批人来源" } },
                              [
                                _c(
                                  "a-select",
                                  {
                                    model: {
                                      value: _vm.editForm.assigneeType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editForm,
                                          "assigneeType",
                                          $$v
                                        )
                                      },
                                      expression: "editForm.assigneeType",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "fixed_user" } },
                                      [_vm._v("固定用户")]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "role" } },
                                      [_vm._v("角色")]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "dept_leader" } },
                                      [_vm._v("部门上级")]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "starter_choose" } },
                                      [_vm._v("发起人指定")]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "field_var" } },
                                      [_vm._v("字段变量")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.editForm.assigneeType === "fixed_user"
                              ? _c(
                                  "a-form-item",
                                  { attrs: { label: "审批人" } },
                                  [
                                    _c(
                                      "a-select",
                                      {
                                        attrs: {
                                          mode: "multiple",
                                          placeholder: "请选择用户",
                                          showSearch: "",
                                          optionFilterProp: "children",
                                        },
                                        model: {
                                          value: _vm.assigneeIdArr,
                                          callback: function ($$v) {
                                            _vm.assigneeIdArr = $$v
                                          },
                                          expression: "assigneeIdArr",
                                        },
                                      },
                                      _vm._l(_vm.userList, function (u) {
                                        return _c(
                                          "a-select-option",
                                          { key: u.id, attrs: { value: u.id } },
                                          [
                                            _vm._v(
                                              _vm._s(u.username || u.loginName)
                                            ),
                                          ]
                                        )
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.editForm.assigneeType === "role"
                              ? _c(
                                  "a-form-item",
                                  { attrs: { label: "角色" } },
                                  [
                                    _c(
                                      "a-select",
                                      {
                                        attrs: {
                                          placeholder: "请选择角色",
                                          showSearch: "",
                                          optionFilterProp: "children",
                                        },
                                        model: {
                                          value: _vm.editForm.roleId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editForm,
                                              "roleId",
                                              $$v
                                            )
                                          },
                                          expression: "editForm.roleId",
                                        },
                                      },
                                      _vm._l(_vm.roleList, function (r) {
                                        return _c(
                                          "a-select-option",
                                          { key: r.id, attrs: { value: r.id } },
                                          [_vm._v(_vm._s(r.name))]
                                        )
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.editForm.assigneeType === "field_var"
                              ? _c(
                                  "a-form-item",
                                  { attrs: { label: "字段名" } },
                                  [
                                    _c("a-input", {
                                      attrs: {
                                        placeholder: "如 creator，对应单据字段",
                                      },
                                      model: {
                                        value: _vm.editForm.assigneeIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.editForm,
                                            "assigneeIds",
                                            $$v
                                          )
                                        },
                                        expression: "editForm.assigneeIds",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.currentEdit.bizType === "approval"
                              ? _c(
                                  "a-form-item",
                                  { attrs: { label: "审批方式" } },
                                  [
                                    _c(
                                      "a-select",
                                      {
                                        model: {
                                          value: _vm.editForm.approveType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editForm,
                                              "approveType",
                                              $$v
                                            )
                                          },
                                          expression: "editForm.approveType",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select-option",
                                          { attrs: { value: "or_sign" } },
                                          [_vm._v("或签（任一通过）")]
                                        ),
                                        _c(
                                          "a-select-option",
                                          { attrs: { value: "sign" } },
                                          [_vm._v("会签（全部通过）")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", block: "" },
                      on: { click: _vm.applyNode },
                    },
                    [_vm._v("应用")]
                  ),
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-top": "8px" },
                      attrs: { type: "danger", block: "" },
                      on: { click: _vm.deleteCurrent },
                    },
                    [_vm._v("删除节点")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.currentEdit && _vm.currentEdit.kind === "edge"
            ? _c(
                "div",
                [
                  _c(
                    "a-form",
                    { attrs: { layout: "vertical" } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "分支类型" } },
                        [
                          _c(
                            "a-radio-group",
                            {
                              model: {
                                value: _vm.editForm.isDefaultBranch,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "isDefaultBranch", $$v)
                                },
                                expression: "editForm.isDefaultBranch",
                              },
                            },
                            [
                              _c("a-radio", { attrs: { value: false } }, [
                                _vm._v("条件分支"),
                              ]),
                              _c("a-radio", { attrs: { value: true } }, [
                                _vm._v("默认分支"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !_vm.editForm.isDefaultBranch
                        ? [
                            _c(
                              "a-form-item",
                              { attrs: { label: "条件关系" } },
                              [
                                _c(
                                  "a-radio-group",
                                  {
                                    model: {
                                      value: _vm.editForm.conditionOp,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editForm,
                                          "conditionOp",
                                          $$v
                                        )
                                      },
                                      expression: "editForm.conditionOp",
                                    },
                                  },
                                  [
                                    _c("a-radio", { attrs: { value: "AND" } }, [
                                      _vm._v("满足全部"),
                                    ]),
                                    _c("a-radio", { attrs: { value: "OR" } }, [
                                      _vm._v("满足任一"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._l(
                              _vm.editForm.conditionList,
                              function (c, idx) {
                                return _c(
                                  "a-form-item",
                                  {
                                    key: idx,
                                    attrs: { label: "条件 " + (idx + 1) },
                                  },
                                  [
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 4 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { span: 9 } },
                                          [
                                            _c(
                                              "a-select",
                                              {
                                                attrs: { placeholder: "字段" },
                                                model: {
                                                  value: c.field,
                                                  callback: function ($$v) {
                                                    _vm.$set(c, "field", $$v)
                                                  },
                                                  expression: "c.field",
                                                },
                                              },
                                              _vm._l(
                                                _vm.conditionFields,
                                                function (f) {
                                                  return _c(
                                                    "a-select-option",
                                                    {
                                                      key: f.value,
                                                      attrs: { value: f.value },
                                                    },
                                                    [_vm._v(_vm._s(f.label))]
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-col",
                                          { attrs: { span: 7 } },
                                          [
                                            _c(
                                              "a-select",
                                              {
                                                attrs: {
                                                  placeholder: "操作符",
                                                },
                                                model: {
                                                  value: c.operator,
                                                  callback: function ($$v) {
                                                    _vm.$set(c, "operator", $$v)
                                                  },
                                                  expression: "c.operator",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-select-option",
                                                  { attrs: { value: ">" } },
                                                  [_vm._v("大于")]
                                                ),
                                                _c(
                                                  "a-select-option",
                                                  { attrs: { value: ">=" } },
                                                  [_vm._v("大于等于")]
                                                ),
                                                _c(
                                                  "a-select-option",
                                                  { attrs: { value: "<" } },
                                                  [_vm._v("小于")]
                                                ),
                                                _c(
                                                  "a-select-option",
                                                  { attrs: { value: "<=" } },
                                                  [_vm._v("小于等于")]
                                                ),
                                                _c(
                                                  "a-select-option",
                                                  { attrs: { value: "==" } },
                                                  [_vm._v("等于")]
                                                ),
                                                _c(
                                                  "a-select-option",
                                                  { attrs: { value: "!=" } },
                                                  [_vm._v("不等于")]
                                                ),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "contains",
                                                    },
                                                  },
                                                  [_vm._v("包含")]
                                                ),
                                                _c(
                                                  "a-select-option",
                                                  { attrs: { value: "in" } },
                                                  [_vm._v("属于(逗号分隔)")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-col",
                                          { attrs: { span: 6 } },
                                          [
                                            _c("a-input", {
                                              attrs: { placeholder: "值" },
                                              model: {
                                                value: c.value,
                                                callback: function ($$v) {
                                                  _vm.$set(c, "value", $$v)
                                                },
                                                expression: "c.value",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-col",
                                          {
                                            staticStyle: {
                                              "text-align": "center",
                                            },
                                            attrs: { span: 2 },
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeCondition(
                                                      idx
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("删")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            _c(
                              "a-button",
                              {
                                attrs: { type: "dashed", block: "" },
                                on: { click: _vm.addCondition },
                              },
                              [_vm._v("+ 增加条件")]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", block: "" },
                      on: { click: _vm.applyEdge },
                    },
                    [_vm._v("应用")]
                  ),
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-top": "8px" },
                      attrs: { type: "danger", block: "" },
                      on: { click: _vm.deleteCurrent },
                    },
                    [_vm._v("删除连线")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.jsonModalVisible,
            title: "流程JSON",
            width: "700px",
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.jsonModalVisible = false
            },
          },
        },
        [
          _c(
            "a-button",
            { attrs: { size: "small" }, on: { click: _vm.formatJson } },
            [_vm._v("格式化")]
          ),
          _c(
            "a-button",
            { attrs: { size: "small" }, on: { click: _vm.compressJson } },
            [_vm._v("压缩")]
          ),
          _c(
            "a-button",
            { attrs: { size: "small" }, on: { click: _vm.copyJson } },
            [_vm._v("复制")]
          ),
          _c("a-textarea", {
            staticStyle: { "margin-top": "8px" },
            attrs: { rows: 18 },
            model: {
              value: _vm.jsonText,
              callback: function ($$v) {
                _vm.jsonText = $$v
              },
              expression: "jsonText",
            },
          }),
          _c(
            "div",
            { staticStyle: { "margin-top": "12px", "text-align": "right" } },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.jsonModalVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "8px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.applyJson },
                },
                [_vm._v("应用")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }